export enum GeneralApiMethods {
    getPaymentProviderDetails = "OrganizationBranches.GetPaymentProviderDetailsPublic",
    getLegalInfo = "OrganizationBranches.GetOrganizationBranchPublicLegalDetails",
    StatsAddEvent = "Stats.AddEvent"
}
